<template>
    <div v-if="loaded" class="glide bng-sport-home-banner">
        <div data-glide-el="track" class="glide__track">
            <ul class="glide__slides">
                <li v-if="isLiveGamesActive" class="glide__slide">
                    <new-live-games-banner />
                </li>
                <li v-if="isDepositBonusActive" class="glide__slide">
                    <deposit-bonus-banner />
                </li>
                <li v-if="isRegistrationBonusActive" class="glide__slide">
                    <registration-bonus-banner />
                </li>
                <li v-if="isCashbackBonusActive" class="glide__slide">
                    <cashback-bonus-banner />
                </li>
                <li v-if="isEmailBonusActive" class="glide__slide">
                    <email-bonus-banner />
                </li>
                <template v-if="customSportBannerImages.length">
                    <li v-for="img in customSportBannerImages" :key="`${img.image}_${img.link}`" class="glide__slide">
                        <template v-if="img.link && img.link.indexOf('/') >= 0">
                            <a :href="img.link"><img :src="img.image" /></a>
                        </template>
                        <template v-else-if="img.link && img.link.indexOf('/') == -1">
                            <router-link :to="{ name: img.link }"><img :src="img.image" /></router-link>
                        </template>
                        <template v-else>
                            <img :src="img.image" />
                        </template>
                    </li>
                </template>
            </ul>
        </div>
        <div v-if="slidesCount > 1" class="glide__bullets" data-glide-el="controls[nav]">
            <button v-for="i in slidesCount" :key="i" class="glide__bullet" :data-glide-dir="`=${i-1}`"></button>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';

import Glide from '@glidejs/glide';

import NewLiveGamesBanner from './new-live-games.vue';
import DepositBonusBanner from './deposit-bonus.vue';
import RegistrationBonusBanner from './registration-bonus.vue';
import CashbackBonusBanner from './cashback-bonus.vue';
import EmailBonusBanner from './email-bonus.vue';

export default {
    name: 'sport-home-banner',
    components: {
        NewLiveGamesBanner,
        DepositBonusBanner,
        RegistrationBonusBanner,
        CashbackBonusBanner,
        EmailBonusBanner
    },
    props: {
        elemId: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            loaded: false,
            isLiveGamesActive: false,
            isDepositBonusActive: false,
            isRegistrationBonusActive: false,
            isCashbackBonusActive: false,
            isEmailBonusActive: false,
            customSportBannerImages: [],
            slidesCount: 0
        };
    },
    async created() {
        await Vue.state.games.ensure();
        await Vue.state.client.ensure();
        let client = Vue.state.client.get();

        this.isLiveGamesActive = Vue.state.games.get().categories.find(c => c.name == 'video-games');
        this.isDepositBonusActive = client.bonus && client.bonus.deposit;
        this.isRegistrationBonusActive = client.bonus && client.bonus.registration;
        this.isCashbackBonusActive = client.bonus && client.bonus.cashback;
        this.isEmailBonusActive = client.bonus && client.bonus.mailing;        

        if (this.isLiveGamesActive) this.slidesCount++;
        if (this.isDepositBonusActive) this.slidesCount++;
        if (this.isRegistrationBonusActive) this.slidesCount++;
        if (this.isCashbackBonusActive) this.slidesCount++;
        if (this.isEmailBonusActive) this.slidesCount++;

        if (client.view.banners.sportCustomBanner) {
            this.customSportBannerImages.push(...client.view.banners.sportCustomBannerImages);
            this.slidesCount += this.customSportBannerImages.length;
        }

        this.loaded = true;

        setTimeout(() => {
            new Glide('.glide', { autoplay: 3000 }).mount();
        });
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/banners/sport-banners/sport-home-banner.vue